import { createContext } from 'react';

export const AppHeaderActionsSlotContext = createContext<HTMLElement | null>(null);
